module.exports = __webpack_public_path__ + "img/solo-sms1.05639fa0.png";